/**
 *
 *
 * 错误码由 4字节组成，低20位为状态码，高12位为模块码
 *
 *
 */

// eslint-disable-next-line
export namespace SenseChat {
  /**
   * 模型码为4096是模型入口模块
   * 模块码为1的是登录认证模块
   * 不为0和4096的模块是业务系统模块
   */
  export enum Module {
    Auth = 1,
    Chat,
    Document,
    ModelAccess = 4096,
  }

  /**
   * 1. 状态码0~9999为非错误类状态码
   * 2. 状态码10000~1000000为错误类状态码
   */
  export enum Status {
    // 状态码0表示成功
    Success,
    // 状态码1表示等待审批
    WaitForApprove = 1,

    // 2000~9999状态码保留

    // 10000~19999 状态码为参数类错误
    ParamError = 10000,
    UnknownAreaError,

    // 20000~29999 状态码为Redis内存数据库类错误
    RedisError = 20000,

    // 30000~39999 状态码为MySQL数据库类错误
    DBError = 30000,

    // 40000~99999 状态码保留

    // 100000~1048576 为业务类错误

    // 100000~109999 为格式类错误
    MobileFormatError = 100000,
    SMSCodeFormatError,
    InvitationFormatError,
    UserNameFormatError,
    PasswordFormatError,
    EmailFormatError,
    UserPasswordFormatError,

    // 110000~119999 为资源类错误
    UserBusy = 110000,
    InvitationExceedTime,
    SMSCodeSendError,
    SMSCodeBusyError,
    SMSCodeHLimitError,
    SMSCodeDLimitError,
    EmailCodeDayLimitError = 110010,

    // 120000~129999 为用户状态类错误
    UserDisableError = 120000,
    // ip 地址禁用
    I_IP_DISABLE_BY_ADDR_ERROR = 120008,
    I_IP_DISABLE_BY_RULE_ERROR = 120009,
    I_IP_DISABLE_BY_COUNTRY_ERROR = 120010,
    I_IP_DISABLE_BY_CITY_ERROR = 120011,

    // 130000~139999 为存在类错误
    MobileUsed = 130000,
    MobileNotExisted = 130001,
    UserNotExisted,
    UserPasswordExisted,
    NoSMSNoPasswordError,
    NoPasswordError,
    MobileHaveUsed = 130009,
    CanNotUnBind = 130012,
    EmailHaveUsed = 130013,
    ThirdAcountHaveUsed = 130016,

    // 140000~149999 为校验类错误
    PasswordError = 140000,
    SMSCodeError,
    SMSCodeStillAliveError,
    InvitationError,
    IneligibleMobileError, // 无资格
    ConfirmNotMatchError,
    OriginNotMatchError,
    OriginModifySameError,
    EmailCodeError = 140010,

    // 150000~159999 为token类错误
    SSOTokenError = 150000,
    SSOTokenExpire,
    TokenCreateError,
    TokenError,
    TokenExpire,

    // 169999~1048576 暂时未定义

    // 160000~169999 为权限类错误
    // 用户无权限
    I_NO_AUTHORITY_ERROR = 160000,
    // 请求头中不带Authoriztion错误
    I_NO_AUTHORIZATION_ERROR = 160001,
    // Authoriztion校验失败
    I_AUTHORIZATION_VALIDATE_FAILED_ERROR = 160002,
    // Authoriztion校验内部错误
    I_AUTHORIZATION_VALIDATE_INTERNAL_ERROR = 160003,

    // 170000~179999 为session类错误
    // 非法的session
    I_SESSION_INVALID_ERROR = 170000,
    // session已删除
    I_SESSION_DELETED_ERROR = 170001,
    // session不可用
    I_SESSION_NOT_AVAILABLE_ERROR = 170002,
    // session的turn id非法
    I_SESSION_TURN_ID_INVALID_ERROR = 170003,
    // session为空错误
    I_SESSION_EMPTY_ERROR = 170003,

    // 180000~189999 为对话类错误
    // 对话输入敏感
    I_CONVERSATION_INPUT_SENSETIVE_ERROR = 180000,
    // 对话输出敏感
    I_CONVERSATION_OUTPUT_SENSETIVE_ERROR = 180001,
    // 对话不可用
    I_CONVERSATION_NOT_AVAILABLE_ERROR = 180002,
    // 对话不存在
    I_CONVERSATION_THINK_SENSETIVE_ERROR = 180003,

    // 190000~199999 为文件类错误
    // 文件解析失败
    I_FILE_PARSE_FAILED = 190000,
    // 文件Token已超限制
    I_FILE_TOKEN_LIMITED_ERROR = 190001,
    // 文件ID非法
    I_FILE_ID_INVALID_ERROR = 190002,
    // 文件TOKEN超限
    I_FILE_TOKEN_LIMIT_ERROR = 190003,

    // 200000~209999 为第三方接口请求失败
    // 第三方SHUMEI接口敏感错误
    I_THIRDPARTY_SHUMEI_SENSETIVE_ERROR = 200000,
    // 第三方火山(volcengine)敏感错误
    I_THIRDPARTY_VOLCENGINE_SENSETIVE_ERROR = 200100,
    // 第三方火山(volcengine)TTS错误
    I_THIRDPARTY_VOLCENGINE_TTS_ERROR = 200101,
    // 第三方阿里云短信发送错误
    I_THIRDPARTY_ALIYUN_SMS_SEND_ERROR = 200200,
    // 第三方阿里云ASR错误
    I_THIRDPARTY_ALIYUN_ASR_ERROR = 200201,
    // 第三方金山云OSS错误
    I_THIRDPARTY_KSYUN_OSS_ERROR = 200300,
    // 第三方实名认证错误
    I_THIRDPARTY_UIA_ERROR = 200400,

    // 210000~219999 为nova的通用对话错误
    // nova无状态对话错误
    I_NOVA_NO_CONTEXT_CHAT_ERROR = 210000,
    // nova有状态对话错误
    I_NOVA_CONTEXTUAL_CHAT_ERROR = 210001,

    // 220000~229999 为nova的MOE对话错误
    I_NOVA_MOE_ASSISTANT_DISABLE_ERROR = 220000,
  }

  export function code2Module(code: number): Module {
    return <Module>Math.round(code / 1000000);
  }

  export function code2Status(code: number) {
    return <Status>(code % 1000000);
  }

  export function createCode(module: Module, status: Status): number {
    if (status === Status.Success) {
      return 0;
    }
    return <number>module * 1000000 + <number>status;
  }
}
